import { Card } from 'antd';
import { useApplicationReportOverview } from '../hooks/useApplicationReportOverview';
import { SharedCardHeader } from './SharedCardHeader';
import { SHARED_CARD_STYLES } from '../constants';
import { TierBadge } from '../../dataInputs/tiers/components';
import { renderApplicationType } from '../columns/it-applications-columns';
import { CompletionPercentage } from '../../cyber/components';

export const ApplicationReportOverviewCard = ({
  applicationUUID,
  locationUUID,
}: {
  applicationUUID: string;
  locationUUID?: string;
}) => {
  const { data } = useApplicationReportOverview(applicationUUID, locationUUID);

  return (
    <Card
      className={SHARED_CARD_STYLES.className}
      headStyle={SHARED_CARD_STYLES.headStyle}
      bodyStyle={{
        ...SHARED_CARD_STYLES.bodyStyle,
        minHeight: '200px',
        height: '100%',
        paddingLeft: '0',
        paddingRight: '0',
        paddingTop: '0',
        paddingBottom: '0',
      }}
      bordered={false}
      title={<SharedCardHeader title="Overview" />}
    >
      <div className="flex flex-col gap-0 text-[#676767] text-[14px]">
        <div className="flex flex-row w-full border-y border-[#CDCDCD]">
          <div className="flex flex-row items-center gap-1 basis-1/2 p-5 border-r border-[#CDCDCD]">
            <span className="font-medium">Hosting Entity: </span>
            <span className="font-semibold">
              {data?.hostingEntity ?? 'Not Provided'}
            </span>
          </div>
          <div className="flex flex-row items-center gap-1 basis-1/2 p-5">
            <span className="font-medium">Tier: </span>
            <span className="font-semibold">
              {data?.tier ? (
                <TierBadge
                  name={data.tier.name}
                  color={data.tier.color}
                  style={{
                    width: '70px',
                    borderRadius: '8px',
                    padding: '3px 8px',
                  }}
                />
              ) : (
                'Not Provided'
              )}
            </span>
          </div>
        </div>
        <div className="flex flex-row w-full border-b border-[#CDCDCD]">
          <div className="flex flex-row items-center gap-1 basis-1/2 p-5 border-r border-[#CDCDCD]">
            <span className="font-medium">Application Type: </span>
            <span className="font-semibold">
              {data?.applicationType
                ? renderApplicationType(data.applicationType)
                : 'Not Provided'}
            </span>
          </div>
          <div className="flex flex-row items-center gap-6 basis-1/2 p-5">
            <span className="font-medium">
              Workaround Timeline Compliance:{' '}
            </span>
            <div className="flex flex-row items-center gap-4">
              <div className="flex flex-col">
                <span className="text-xsm font-semibold">SLA</span>
                <CompletionPercentage
                  percent={data?.sla || 0}
                  colorize={true}
                />
              </div>
              <div className="flex flex-col">
                <span className="text-xsm font-semibold">RTO</span>
                <CompletionPercentage
                  percent={data?.rto || 0}
                  colorize={true}
                />
              </div>
              <div className="flex flex-col">
                <span className="text-xsm font-semibold">MTO</span>
                <CompletionPercentage
                  percent={data?.mto || 0}
                  colorize={true}
                />
              </div>
              <div className="flex flex-col">
                <span className="text-xsm font-semibold">RPO</span>
                <CompletionPercentage
                  percent={data?.rpo || 0}
                  colorize={true}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="p-5 w-full">
          <span className="font-medium">Description: </span>
          <span className="font-semibold text-justify">
            {data?.description ?? 'Not Provided'}
          </span>
        </div>
      </div>
    </Card>
  );
};
